import Typography from '@mui/material/Typography';

interface CharactersCounterProps {
  maxValue: number;
  currentValue?: number;
  dataTest?: string;
}

export function CharactersCounter({
  maxValue,
  currentValue = 0,
  dataTest = 'characters-counter',
}: CharactersCounterProps) {
  return (
    <Typography align="right" variant="body2" data-test={dataTest}>
      {currentValue}/{maxValue}
    </Typography>
  );
}
